import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MobileMenu from "./MobileMenu";

export default function Navbar() {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-foreground-200/40">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-6 h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-1.5 cursor-pointer flex-shrink-0">
            <span className="font-heading text-lg text-foreground-950">CSSBuy</span>
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
            <span className="font-heading text-lg text-foreground-950">Sheet</span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap font-medium"
            >
              <i className="ri-home-4-line w-4 h-4 inline-flex items-center justify-center mr-1"></i>
              Início
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap font-medium"
            >
              <i className="ri-shopping-bag-3-line w-4 h-4 inline-flex items-center justify-center mr-1"></i>
              Guia de Compras
            </a>
            <Link
              to="/artigo/cssbuy-spreadsheet"
              className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap"
            >
              {t("nav.articles")}
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              VER SPREADSHEET
              <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(true)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            aria-label="Abrir menu"
          >
            <i className="ri-menu-line text-xl w-5 h-5 flex items-center justify-center"></i>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <MobileMenu isOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
    </>
  );
}